export interface ITheme {
  primary: {
    main: "#013C5C";
    light: "#00B9E0";
    dark: "#003c58";
    background: "#E5E5E5";
    font: "#5f6165";
  };

  secondary: {
    main: string;
    light: string;
    dark: string;
    background: string;
  };
}

export const theme: ITheme = {
  primary: {
    main: "#013C5C",
    light: "#00B9E0",
    dark: "#003c58",
    background: "#E5E5E5",
    font: "#5f6165",
  },

  secondary: {
    main: "",
    light: "",
    dark: "",
    background: "",
  },
};
